import { Grid, Typography as T, Loading } from '../../../components';
import { useNavigate, useLocation } from 'react-router-dom';
import { navRoutes, userRoles } from '../../../constants';
import useCustomTrainingStepHook from './Hooks/useCustomTrainingStepHook';
import { JoinOurCommunity } from 'components/JoinOurCommunity';
import { FurtherResources } from 'components/FurtherResources';
import { Divider } from 'components/Divider';
import { CompleteTrainingCongratsDialog } from 'components/CompleteTrainingCongratsDialog';
import { useCallback, useEffect, useState } from 'react';
import { useUpdateCoachCompletedTrainingDay } from 'api-calls/coaches.queries';
import PlayWithTheTool from 'components/PlayWithTheTool';
import { useAuth } from 'context/auth';
import useCoachTrainingData from './Hooks/useCoachTraining';

const { Row, Col } = Grid;

const TrainingComplete = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const {
    user: { id: userId },
  } = useAuth();
  const [showCongratsDialog, setShowCongratsDialog] = useState(false);

  const { mutateAsync: updateCoach, isLoading: isUpdatingCoachLoading } =
    useUpdateCoachCompletedTrainingDay();
  const { trainingData } = useCoachTrainingData();

  const { activeStep, isAPILoading, customTrainingResources } =
    useCustomTrainingStepHook();

  useEffect(() => {
    if (!!state?.showCongrats) {
      setShowCongratsDialog(true);
      window.history.replaceState({}, document.title);
    }
  }, [state]);

  const hideCongratsDialog = useCallback(() => {
    setShowCongratsDialog(false);
  }, []);

  useEffect(() => {
    if (activeStep < trainingData.length) return;

    const updatingCoachOnBoardingAndCompletedTrainingDate = async () => {
      await updateCoach({
        coachId: userId,
        completedTrainingAt: new Date(),
      });
    };
    updatingCoachOnBoardingAndCompletedTrainingDate();
  }, [activeStep, userId, updateCoach, trainingData.length]);

  if (isAPILoading || isUpdatingCoachLoading) return <Loading />;

  if (activeStep < trainingData.length)
    return navigate(navRoutes.COACH.TRAINING);

  return (
    <Row dir="column" jc="center">
      <Col w={[4, 10, 10]}>
        <T.H1 weight="bold" color="neutralMain">
          🎉 Training complete!
        </T.H1>
      </Col>
      <Col w={[4, 10, 10]} mt="2" mb="5">
        <T.P>
          You’ve now completed all the essential facilitator training. You’re
          ready to start onboarding some coaches and learners! Remember you can
          review any of the training as much as you like by clicking the
          Training section in your menu above.
        </T.P>
      </Col>

      <Col w={[4, 10, 10]}>
        <T.H2 weight="bold" color="neutralMain" mb="2">
          Here are the key points you need to know
        </T.H2>
        <T.P>
          You’ve now completed all the essential facilitator training. You’re
          ready to start onboarding some coaches and learners! Remember you can
          review any of the training as much as you like by clicking the
          Training section in your menu above.
        </T.P>
      </Col>
      <Col w={[4, 10, 10]}>
        <Divider />
      </Col>
      <Col w={[4, 10, 10]}>
        <PlayWithTheTool />
      </Col>
      <Col w={[4, 10, 10]}>
        <Divider />
      </Col>
      <Col w={[4, 10, 10]}>
        <JoinOurCommunity />
      </Col>
      <Col w={[4, 10, 10]}>
        <Divider />
      </Col>
      <Col w={[4, 10, 10]}>
        <FurtherResources customTrainingResources={customTrainingResources} />
      </Col>

      {showCongratsDialog ? (
        <CompleteTrainingCongratsDialog
          visible={showCongratsDialog}
          onCancel={hideCongratsDialog}
          role={userRoles.COACH}
        />
      ) : null}
    </Row>
  );
};

export default TrainingComplete;
